import React from 'react'

const Login = () => {
  return (
    <div>
      <h1>hii </h1>
    </div>
  )
}

export default Login

